var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"on-click-away",rawName:"v-on-click-away",value:(_vm.hide_picker),expression:"hide_picker"}],staticClass:"answers_date"},[_c('masked-input',{class:['date', { error: !_vm.valid }],attrs:{"mask":[
      /[0-3]/,
      /[0-9]/,
      '-',
      /[0-1]/,
      /[0-9]/,
      '-',
      /[1-2]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ],"type":"text","keepCharPositions":true,"placeholder":_vm.$tr(_vm.placeholder)},on:{"input":_vm.set_date,"focus":_vm.open_picker},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),(_vm.show_picker)?_c('calendar',{staticClass:"date-range",attrs:{"show-lunar":false,"first-day-of-week":1,"lang":_vm.current_locale},on:{"change":_vm.change}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }